import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { ContentProvider } from '../../context/ContentContext';
import Home from '../Home';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import About from '../About';
// import Awards from '../Awards';
import Publications from '../Publications';
import Films from '../Films';
import Contact from '../Contact';
import Events from '../Events';
import Teaching from '../Teaching';
import TwentyEightDays from '../TwentyEightDays';
import './App.css';
import BrandedWork from '../BrandedWork';

const App = () => (
  <ContentProvider>
    <div className="app">
      <Header />
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route exact path="/about">
          <About />
        </Route>
        {/* The book has its own tab as well as the landing page. Both render the
            same component, so the Airtable copy stays the single source. */}
        <Route path="/themotherwound">
          <Home />
        </Route>
        {/* <Route exact path="/awards">
          <Awards />
        </Route> */}
        <Route exact path="/writing">
          <Publications />
        </Route>
        <Route exact path="/editorial">
          <BrandedWork />
        </Route>
        <Route exact path="/movies/other-movies">
          <Films />
        </Route>
        <Route path="/movies">
          <TwentyEightDays />
        </Route>
        <Route exact path="/pedagogy">
          <Teaching />
        </Route>
        <Route exact path="/contact">
          <Contact />
        </Route>
        <Route exact path="/events">
          <Events />
        </Route>
        {/* <Route exact path="/branded-content">
          <Gallery />
        </Route> */}
      </Switch>
      <Footer />
    </div>
  </ContentProvider>
);

export default App;
